import { render, staticRenderFns } from "./BoardDonutChart.vue?vue&type=template&id=264b9e34&scoped=true&"
import script from "./BoardDonutChart.vue?vue&type=script&lang=ts&"
export * from "./BoardDonutChart.vue?vue&type=script&lang=ts&"
import style0 from "./BoardDonutChart.vue?vue&type=style&index=0&id=264b9e34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b9e34",
  null
  
)

export default component.exports